import { useContext } from 'react';
import ToastContext from 'components/ui-kit/toast/context/toastContext';

const useToast = () => useContext(ToastContext);

export default useToast;
